import React from 'react';

import { Link } from '~/lib/react-router-dom';

import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';

export type EvergreenShipConflict = {
  shipName: string;
  inclusionId: string;
};

type Props = {
  conflicts: Array<EvergreenShipConflict>;
  onClose: () => void;
};

export default function EvergreenShipConflictsModal({ conflicts, onClose }: Props) {
  return (
    <Dialog open={conflicts.length > 0} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Ships in other inclusions</DialogTitle>
      <DialogContent>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          It is not possible to have two inclusions with the same ship
        </Typography>
        <Stack spacing={1}>
          {conflicts.map((conflict) => (
            <Card key={`${conflict.inclusionId}-${conflict.shipName}`} variant="outlined">
              <CardContent
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'space-between',
                  py: 1.5,
                  '&:last-child': { pb: 1.5 },
                }}
              >
                <Typography>{conflict.shipName}</Typography>
                <Button
                  component={Link}
                  to={`/cruises/inclusions/edit/${conflict.inclusionId}/items`}
                  size="small"
                  target="_blank"
                  rel="noreferrer"
                >
                  View inclusion
                </Button>
              </CardContent>
            </Card>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
